import column from '../../../../common/list-table/helpers/columns';

export default (data, userRole, onRowDelete, onRowEdit) => {
  const { FilteredTextColumn, FilteredNullableBooleanColumn, ActionColumn } = column(data);

  const conditionalDisplay = (row) => (userRole === 'IPC_ADMIN' ? true : !row.original.ipcContact);

  return [
    {
      Header: '',
      columns: [
        new FilteredTextColumn('Contact ID', 'id').withShow(false),
        new FilteredTextColumn('First Name', 'firstName'),
        new FilteredTextColumn('Last Name', 'lastName'),
        new FilteredTextColumn('Phone', 'phoneNumber').withWidth(200),
        new FilteredTextColumn('E-mail', 'emailAddress').withWidth(440),
        new FilteredNullableBooleanColumn('Notify for failure', 'notifyOnFailure').withWidth(180),
        new ActionColumn([['DELETE', 'id', onRowDelete, true, conditionalDisplay],
          ['EDIT', 'id', onRowEdit, true, conditionalDisplay]]).withShow(['IPC_ADMIN', 'OPER_ADMIN'].includes(userRole)).withWidth(100),
      ],
    },
  ];
};
